export enum RecordableTypeName {
    Recordables = 1,
    Schedules = 2,
    Service = 3
}
